module.exports = __webpack_public_path__ + "img/emptydata4.f13c1228.gif";